import { create } from 'zustand';
import { setAdminSecretProvider } from '../lib/api';

/**
 * Holds the platform-admin secret used for /v1/admin/* requests. Kept in
 * sessionStorage (not localStorage) so it survives reloads within the tab but is
 * dropped when the tab closes — it never persists across browser sessions.
 */
const KEY = 'urblock_admin_secret';

interface AdminSecretState {
  secret: string;
  setSecret: (value: string) => void;
  clear: () => void;
}

export const useAdminSecretStore = create<AdminSecretState>((set) => ({
  secret: (typeof sessionStorage !== 'undefined' && sessionStorage.getItem(KEY)) || '',
  setSecret: (value) => {
    if (typeof sessionStorage !== 'undefined') sessionStorage.setItem(KEY, value);
    set({ secret: value });
  },
  clear: () => {
    if (typeof sessionStorage !== 'undefined') sessionStorage.removeItem(KEY);
    set({ secret: '' });
  },
}));

/* Feed the secret to the api client so /v1/admin/* requests carry x-admin-secret. */
setAdminSecretProvider(() => useAdminSecretStore.getState().secret || null);
